import React, { useState, useEffect } from "react";
import {
  Steps,
  Button,
  Form,
  Input,
  message,
  Radio,
  Flex,
  Card,
  Row,
  Col,
  Tag,
  Spin,
} from "antd";
import family from "../Assets/Onboardingimages/family.png";
import school from "../Assets/Onboardingimages/school.png";
import thinking from "../Assets/Onboardingimages/thinking.png";
import individual from "../Assets/Onboardingimages/individual.png";
import Projectmanagement from "../Assets/Onboardingimages/Projectmanagement.png";
import signupsuccess from "../Assets/Onboardingimages/signupsuccess.png";
import schoolrepresentative from "../Assets/Dashboardimages/schoolrepresentative.png";
import familymember from "../Assets/Dashboardimages/familymember.png";
import coparentprofile from "../Assets/Dashboardimages/coparentprofile.png";

import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";

import axios from "axios";
import { URL } from "../helper/Mainurl";

import "../App.css";
import { HeaderSection } from "./HeaderSection";
import { FooterSection } from "./FooterSection";
import { set } from "lodash";

const { Step } = Steps;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const Signup = () => {
  const [current, setCurrent] = useState(0);
  const [form] = Form.useForm();
  const [formGoogle] = Form.useForm();
  const [value, setValue] = useState(1);
  const [isSubmitted, setIsSubmitted] = useState(false); // New state to track form submission
  const [selected, setSelected] = useState([]);
  const [formdata, setFormData] = useState({ name: "", email: "" });
  const [googleId, setGoogleId] = useState("");
  const [showGoogleSignup, setShowGoogleSignup] = useState(false);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const statetoken = queryParams.get("state");
  const sourcetoken = queryParams.get("source");
  const { state, apitoken, apistatus, apimessage, source } = useParams();

  const [emailVerified, setEmailVerified] = useState(false); // New state to track email verification
  const [formSubmitted, setFormSubmitted] = useState(false); // New state to track form submission
  const [loading, setLoading] = useState(false); // New state for loading indicator
  const [prefilledemail, setPrefilledemail] = useState("");
  const [initialNormalSignupEmail, setInitialNormalSignupEmail] = useState("");
  const [verifyingEmail, setVerifyingEmail] = useState(false); // New state
  const [userCategories, setUserCategories] = useState([]);
  const [quelldfeatures, setQuelldfeatures] = useState([]);
  const [userId, setUserId] = useState(null); // State to store user ID
  const [googleVerify, setGoogleVerify] = useState(false);
  const [password, setPassword] = useState("");
  // console.log("BASE_URL::::", BASE_URL);

  // const { state } = useParams();

  const location = useLocation();

  const emailFromState = location.state?.email || "";

  const emailfrominvite = location.state?.invite_email || "";

  // console.log("emailfrominvite::::::::::::", emailfrominvite);
  const inviteIdfromState = location.state?.invite_id || "";

  // console.log("inviteIdfromState::::::::::::", inviteIdfromState);
  if (inviteIdfromState) {
    localStorage.setItem("inviteId", inviteIdfromState); // Store invite ID in localStorage
  }

  const [normalSignupEmail, setNormalSignupEmail] = useState(
    emailFromState || emailfrominvite
  ); // New state for normal signup email

  useEffect(() => {
    if (normalSignupEmail) {
      form.setFieldsValue({ email: normalSignupEmail });

      // ✅ Clear validation error immediately
      form.validateFields(["email"]).catch(() => {});
    }
  }, [normalSignupEmail, form]);
  const googlesignuppage = location.state?.showGoogleSignup ?? false;

  const navigate = useNavigate();

  // Handle button selection with max 3 selections
  const handleSelect = (id) => {
    setSelected((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id); // Deselect if already selected
      } else if (prev.length < 3) {
        return [...prev, id]; // Select if within limit
      } else {
        message.warning("You can select up to 3 items only!");
        return prev;
      }
    });
  };

  const handleSignup = async (values) => {
    // console.log("Submitted Values:", values); // Debugging
    setFormSubmitted(true); // Set formSubmitted to true when the form is submitted
    setLoading(true); // Show the loader
    const payload = {
      name: values.name,
      email: inviteIdfromState ? emailfrominvite : values.email,
      password: values.password,
      ...(inviteIdfromState ? { invite_id: inviteIdfromState } : {}), // Add only if available
    };
    try {
      const response = await fetch(`${URL}/register-user`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.message === "This email is already registered.") {
        message.error(
          "This email is already registered. Please check your email"
        );
        return;
      }
      if (response.ok) {
        if (data.code == 200) {
          // Use data.code instead of code
          message.success(data.message);
          setPrefilledemail(""); // Reset email
          setLoading(false); // Hide the loader
        } else if (data?.error) {
          message.error(data.error);
        } else if (data?.allowed === false) {
          message.error(
            "Only @gmail.com, Google Workspace, @icloud.com, and iCloud Suite emails are allowed."
          );
        }
      } else {
        setLoading(false); // Hide the loader
        message.error(
          data?.message || "Something went wrong. Please try again."
        );
      }
    } catch (error) {
      setFormSubmitted(false); // Reset formSubmitted on error
      setLoading(false); // Hide the loader
      // message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const onChange = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    // Function to call the signup URL

    const { normalSignup, email: emailFromState } = location.state || {}; // Destructure, handle missing state

    if (normalSignup) {
      setShowGoogleSignup(false);
      setInitialNormalSignupEmail(emailFromState || emailfrominvite); // Set initial normal signup email
      setNormalSignupEmail(emailFromState || emailfrominvite);
      return; // Stop here; no need to check Google params
    }

    const checkSignupEligibility = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/signup`, {
          params: {
            state: apitoken,
            status: apistatus,
            message: apimessage,
            source: source,
          },
        });

        // console.log("response::::::email:::::", response);
        const data = response.data; // Correct way to access Axios response data

        if (response.status == 200) {
          if (!emailVerified) {
            setShowGoogleSignup(true);
            // message.success("fill the form");
            if (sourcetoken) {
              setVerifyingEmail(true); // Set verifying email to true.
              setCurrent(1);
              await callemailVerifyToken(sourcetoken);
            }
          }
        }
      } catch (err) {
        // setError(err.message);
      }
    };
    const callemailVerifyToken = async (sourcetoken) => {
      try {
        const response = await fetch(
          `${URL}/email-verification-status?token_key=${statetoken}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        // console.log("response>>>>>emailverify", response.data);

        if (
          data.code == 200 &&
          data?.data?.emailVerified == true &&
          data?.data?.user_id
        ) {
          setEmailVerified(true);
          // setCurrent(1)
          setUserId(data.data.user_id);
          // console.log("user_id", data.data.user_id);

          setShowGoogleSignup(false); // Hide the Google signup form immediately

          setEmailVerified(true);
          setVerifyingEmail(false); // Reset the flag
        } else {
          // message.error("Email not verified or user data not found:", data?.message);
          setFormSubmitted(false); // Reset formSubmitted if verification fails
          setVerifyingEmail(false); // Reset the flag

          // More informative warning
        }
      } catch (err) {
        console.error("Error in second API call:", err);
        setVerifyingEmail(false); // Reset the flag
      }
    };
    checkSignupEligibility();
  }, [apitoken, apistatus, apimessage, source, sourcetoken, current]);

  useEffect(() => {
    if (emailVerified && formSubmitted) {
      // Check both emailVerified AND formSubmitted
      //  setCurrent(1);
      setEmailVerified(false);
      setFormSubmitted(false);
      // message.success("Signup successful!");
      form.resetFields();
      setLoading(false); // Hide the loader

      // Clear the form
    }
  }, [emailVerified, form, formSubmitted]); //

  const handlegetGoogleData = async () => {
    try {
      const response = await fetch(
        `${URL}/v1/auth/google/auth-data?auth_key=${statetoken}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("response>>>>>", response);
      if (!response.ok) {
        throw new Error("Failed to fetch Google data");
      }

      const data = await response.json();
      // console.log("in Signup response>>>>>", response.data);

      if (data.code == 200) {
        const { google_id, email, name, token } = data.data;
        setGoogleId(google_id); // Store Google ID in state
        setFormData({ email, name }); // Store user details

        if (token) {
          message.success("Login Succesffully");
          navigate("/dashboard");
          localStorage.setItem("authToken", token); // Store token in localStorage

          // Or history.push('/dashboard') if you're using useHistory
        } else if (!token) {
          // If no token, show Google signup
          // message.success("Please Sign up First");
          setShowGoogleSignup(true);
        }
      } else {
        console.warn("User data not found in response");
      }
    } catch (error) {
      // message.error("Error fetching Google data:", error);
    }
  };

  useEffect(() => {
    handlegetGoogleData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formdata, name: e.target.value });
  };

  const handleNormalSignupEmailChange = (e) => {
    setNormalSignupEmail(e.target.value); // Update the *current* normal signup email state
    form.setFieldsValue({ email: value }); // Ensure the form gets the updated value
  };

  const handleSignupWithGoogle = async (googlevalues) => {
    let inviteId = localStorage.getItem("inviteId"); // Retrieve invite ID from localStorage
    // console.log("handleSignupWithGoogle::::::::::::", inviteId);
    const payload = {
      name: formdata.name,
      email: formdata.email,
      google_id: googleId,
      ...(inviteId ? { invite_id: inviteId } : {}), // Add only if available
    };

    try {
      setLoading(true); // Show the loader
      const response = await fetch(`${URL}/v1/auth/google/complete-signup`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data.code == 200 && data.data?.user_id) {
        localStorage.removeItem("inviteId"); // Clear invite ID from localStorage after successful signup
        setUserId(data.data.user_id);
        setGoogleVerify(true);
        // console.log("userId", data.data.user_id);
        // message.success("Signup successful!");
      }

      // console.log("response:::::::", response);

      setLoading(false); // Hide the loader
      if (!response.ok) {
        setLoading(false); // Hide the loader on error
        // console.log("data--response>>>>>>>>>", data);
        // Check if email is already registered
        if (data?.errors?.email) {
          message.error(data.errors.email[0]); // Show the specific email error
        } else {
          message.error(data.message || "Signup failed"); // General error
        }
        return; // Stop execution on error
      }

      // setEmail('')
    } catch (error) {
      // message.error(error.message);
      setLoading(false); // Hide the loader on error
    }
  };

  const handlemetaData = async () => {
    try {
      setLoading(true); // Show the loader
      const response = await fetch(`${URL}/v1/get-onboarding-metadata`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      });
      const data = await response.json();
      if (response.ok) {
        setUserCategories(data.data.user_category || []);
        setQuelldfeatures(data.data.quelld_features || []);
        setLoading(false); // Hide the loader
      } else {
        console.error("Error fetching metadata:", data.message);
        message.error("Error fetching metadata:", data.message);
        setLoading(false); // Hide the loader
      }
    } catch (error) {
      console.error("Fetch request failed:", error);
      setLoading(false); // Hide the loader
    }

    // message.error(error.message);
  };
  useEffect(() => {
    handlemetaData();
  }, []);

  const handlepostmetadata = async () => {
    const payload = {
      user_id: userId,
      user_category_id: value,
    };
    const response = await fetch(`${URL}/v1/onboarding-step-one`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (data.code == 200) {
      // Use data.code instead of code
      setCurrent(2);
      message.success(data.message);
      setLoading(false); // Hide the loader
    } else {
      message.error("Please select your status");
      setLoading(false); // Hide the loader
    }
  };

  const getImageForCategory = (categoryValue) => {
    // console.log("categoryValue", categoryValue,userCategories)
    let imageUrl = userCategories.find(
      (category) => category.id == categoryValue
    )?.file_url;
    // console.log("imageUrl", imageUrl)
    if (imageUrl) {
      return imageUrl;
    }
    // switch (categoryValue) {
    //   case "4":
    //     return family;
    //   case "5":
    //     return schoolrepresentative;
    //   case "6":
    //     return familymember;
    //     case "7":
    //     return coparentprofile;
    // }
  };

  const getDescriptionForCategory = (categoryValue) => {
    switch (categoryValue) {
      case "parent":
        return "With school-aged child/children (3-17)";
      case "school representative":
        return "An individual employed by an educational institution.";
      default:
        return "I'll do this later";
    }
  };

  const steps = [
    {
      title: <div style={{ fontSize: "14px" }}>Input form</div>,
      content: (
        <>
          {showGoogleSignup ? (
            <Form
              form={formGoogle}
              layout="vertical"
              initialValues={{}}
              onFinish={handleSignupWithGoogle}
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Please enter your email!" },
                  {
                    pattern:
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: "Please enter a valid email address!",
                  },
                ]}
              >
                <div className="floating-label">
                  <Input
                    id="signupEmail"
                    placeholder=" "
                    disabled
                    value={formdata.email}
                    style={{ height: "40px" }}
                  />
                  <label htmlFor="signupEmail">Email</label>
                </div>
              </Form.Item>
              <Form.Item
                name="name"
                rules={[
                  { required: true, message: "Please enter your full name!" },
                  { min: 3, message: "Name must be at least 3 characters!" },
                ]}
              >
                <div className="floating-label">
                  <Input
                    placeholder=" "
                    id="signupFName"
                    value={formdata.name}
                    onChange={handleChange} // ✅ Add onChange handler
                    style={{ height: "40px" }}
                  />
                  <label htmlFor="signupFName">Full name</label>
                </div>
              </Form.Item>
              {/* <span style={{ fontSize: "12px", color: "#767A83" }}> Minimum 3 character</span> */}

              {/* <Form.Item name='password'  rules={[
{ required: true, message: "Please enter your password!" },
{
pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/,
message: "Password must have 8+ characters, 1 uppercase, 1 number, and 1 special character!",
},
]}>
   <div className='floating-label'>
     <Input.Password 
   placeholder=" "
   autoComplete="off"
    />
   
     <label>Password</label>
   </div>

 </Form.Item> */}
              {/* <span style={{ fontSize: "12px", color: "#767A83" }}> Minimum 3 character</span> */}
            </Form>
          ) : (
            <>
              <Form form={form} layout="vertical" onFinish={handleSignup}>
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: "Please enter your email!" },
                    {
                      pattern:
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                      message: "Please enter a valid email address!",
                    },
                  ]}
                >
                  <div className="floating-label">
                    <Input
                      id="signEmail"
                      placeholder=" "
                      onChange={handleNormalSignupEmailChange} // Call the new handler
                      value={normalSignupEmail}
                      disabled={!!emailfrominvite} // Disable input if invite_email exists
                      style={{ height: "40px" }}
                      // Use the current normal signup email state
                    />
                    <label htmlFor="signEmail">Email</label>
                  </div>
                </Form.Item>
                <Form.Item
                  name="name"
                  rules={[
                    { required: true, message: "Please enter your full name!" },
                    { min: 3, message: "Name must be at least 3 characters!" },
                  ]}
                >
                  <div className="floating-label">
                    <Input
                      id="signFullName"
                      placeholder=" "
                      style={{ height: "40px" }}
                    />
                    <label htmlFor="signFullName">Full name</label>
                  </div>
                </Form.Item>
                {/* <span style={{ fontSize: "12px", color: "#767A83" }}> Minimum 3 character</span> */}

                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "Please enter your password!" },
                    {
                      pattern:
                        /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/,
                      message:
                        "Password must have 8+ characters, 1 uppercase, 1 number, and 1 special character!",
                    },
                  ]}
                >
                  <div className="floating-label">
                    <Input.Password
                      id="signPass"
                      placeholder=" "
                      autoComplete="off"
                    />

                    <label htmlFor="signPass">Password</label>
                  </div>
                </Form.Item>
                {/* <span style={{ fontSize: "12px", color: "#767A83" }}> Minimum 3 character</span> */}
              </Form>{" "}
            </>
          )}
        </>
      ),
    },
    {
      title: <div style={{ fontSize: "14px" }}>Your status</div>,
      content: (
        <Form form={form} layout="vertical" name="step2" initialValues={{}}>
          <Row gutter={[32, 32]} justify="center">
            {userCategories
              .filter((cate) => cate.file_name !== "School Representative")
              .map((category, index, ar) => {
                return (
                  <Col
                    className={`${
                      category.id === 67 ? "second-row" : "first-row"
                    }`}
                    key={category.id}
                    xs={24}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                  >
                    <Card
                      hoverable
                      onClick={() => setValue(category.id)}
                      className="step2-card"
                    >
                      <div className="step2-img">
                        <img
                          src={getImageForCategory(category.id)}
                          width={35}
                        />
                      </div>
                      <div className="step2-card-headings">
                        {category.label_name}
                      </div>
                      <div className="step2-card-content">
                        {category.description}
                      </div>
                      <div className="step2-radio-btn">
                        <Radio
                          value={category.id}
                          checked={value === category.id}
                          onChange={onChange}
                        />
                      </div>
                    </Card>
                  </Col>
                );
              })}
          </Row>
        </Form>
      ),
    },
    {
      title: <div style={{ fontSize: "14px" }}>Your needs</div>,
      content: (
        <div className="step-3">
          <div className="step3-selection">
            {quelldfeatures.map((features) => (
              <Button
                key={features.id}
                type={selected.includes(features.id) ? "primary" : "default"}
                onClick={() => handleSelect(features.id)}
                style={{
                  borderRadius: "5px",
                  padding: "8px 16px",
                  fontSize: "14px",

                  background: selected.includes(features.id)
                    ? "#9A4FE0"
                    : "white",
                  color: selected.includes(features.id) ? "white" : "#1D2433",
                  border: "1px solid #D9D9D9",
                }}
              >
                {features.label_name}
              </Button>
            ))}
          </div>
          <div className="step3-selection-count">
            <span style={{ color: "#9A4FE0" }}>{selected.length} </span>{" "}
            <span style={{ color: "#767A83", paddingLeft: "3px" }}>
              of 3 Selected
            </span>
          </div>
        </div>
      ),
    },
  ];

  const next = async () => {
    form.validateFields().then((values) => {
      setLoading(true); // Show the loader

      if (googleId && current == 0) {
        handleSignupWithGoogle();
        setCurrent((prev) => prev + 1);
      } else if (emailVerified || googleVerify) {
        handlepostmetadata();
        // setCurrent((prev) => prev + 1);
      } else {
        handleSignup(values);
        // setCurrent((prev) => prev + 1);
      }
      // setCurrent((prev) => prev + 1);
    });
  };

  //   const prev = () => {
  //     setCurrent((prev) => prev - 1);
  //   };

  const onSubmit = async () => {
    const payload = {
      user_id: userId,
      user_category_id: value,
      quelld_features: selected,
    };
    // console.log("quelldfeatures:::::", quelldfeatures);

    try {
      const response = await fetch(`${URL}/v1/onboarding`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data.code == 200) {
        // Use data.code instead of code
        // message.success(data.message);
        setIsSubmitted(true); // Set state to show success image
      } else {
        message.error(data?.message || "Failed to complete onboarding");
      }
    } catch (error) {}
  };

  const handleRedirectLogin = () => {
    navigate("/");
  };

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <HeaderSection />
      <div className="scrollable-content">
        <div className="signup-page">
          <div className="signup-visual">
            <img src="/quelld-signup.png" className="signup-hero" />
          </div>

          <div className="signup-form-wrapper">
            {isSubmitted ? ( // Conditionally render the image after submission
              <>
                <div className="signup-visual signup-success-visual">
                  <img src={signupsuccess} className="signup-success-img" />
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "28px",
                      justifyContent: "center",
                      display: "flex",
                      fontWeight: "500",
                    }}
                  >
                    Sign up successful
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      justifyContent: "center",
                      display: "flex",
                      textAlign: "center",
                      color: "#767A83",
                      paddingTop: "10px",
                    }}
                  >
                    Welcome aboard! Please sign in to start exploring our
                    exciting features now
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      justifyContent: "center",
                      display: "flex",
                      textAlign: "center",
                      color: "#9A4FE0",
                      fontWeight: "500",
                      paddingTop: "48px",
                      cursor: "pointer",
                    }}
                    onClick={handleRedirectLogin}
                  >
                    Sign in to Daily List
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="signup-text">
                  <Row gutter={[16, 32]}>
                    <Col span={24}>
                      <div style={{ fontSize: "28px", fontWeight: "500" }}>
                        {" "}
                        {current === 0
                          ? "Sign up with email"
                          : current === 1
                          ? "Tell us a bit about you..."
                          : current === 2
                          ? "Tell us a bit about you..."
                          : ""}
                      </div>
                    </Col>

                    <Col span={24}>
                      <div style={{ color: "#767A83", fontSize: "14px" }}>
                        {" "}
                        {current === 0
                          ? "Create your personal account now. With your email, you can  access your account anytime, anywhere"
                          : current === 1
                          ? "Please select the status that best describes you currently, so we can optimize each user category in the future"
                          : current === 2
                          ? "Please select the status that best describes you currently, so we can optimize each user category in the future"
                          : ""}
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="signup-steps-wrapper">
                  <Steps
                    current={current}
                    labelPlacement="vertical"
                    size="small"
                  >
                    {steps.map((step, index) => (
                      <Step key={index} title={step.title} />
                    ))}
                  </Steps>
                </div>

                <div className="signup-steps-content">
                  {steps[current].content}
                </div>

                <div className="signup-actions">
                  {current < steps.length - 1 && (
                    <Button
                      type="primary"
                      onClick={() => next()}
                      className="signup-primary-action"
                      disabled={loading}
                    >
                      Next
                    </Button>
                  )}
                  {current === steps.length - 1 && (
                    <Button
                      type="primary"
                      onClick={onSubmit}
                      className="signup-primary-action"
                    >
                      Sign Up
                    </Button>
                  )}
                  <div
                    style={{
                      color: "#767A83",
                      fontSize: "14px",
                      marginTop: "48px",
                    }}
                  >
                    {" "}
                    {current === 0 ? (
                      <>
                        By signing up, you agree to Quelld{" "}
                        <span style={{ color: "#9A4FE0" }}>
                          {" "}
                          Terms of Service
                        </span>{" "}
                        and{" "}
                        <span style={{ color: "#9A4FE0" }}>
                          Privacy <br /> Policy
                        </span>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <FooterSection />
    </div>
  );
};

export default Signup;
